import { ICommand } from 'core-ts-types';
import * as moment from 'moment';

export interface ITodoDateRange {
  start: string;
  end: string;
}

export class TodoDateRangeService {
  private startDate: moment.Moment;
  private endDate: moment.Moment;
  private __dateFormat: string;
  private __axDateFormat: string;

  constructor() {
    this.__dateFormat = 'YYYY-MM-DD';
    this.__axDateFormat = 'MM/DD';
    this.startDate = moment();
    this.endDate = moment().add(2, 'w');
  }

  getCurrentDateRange(): ITodoDateRange {
    return {
      start: this.startDate.format(this.__dateFormat),
      end: this.endDate.format(this.__dateFormat)
    };
  }

  getShowMoreDateRange(): ITodoDateRange {
    return {
      start: this.startDate.format(this.__dateFormat),
      end: this.endDate.add(2, 'w').format(this.__dateFormat)
    };
  }

  getShowMoreDateRangeText(): ITodoDateRange {
    return {
      start: this.startDate.format(this.__axDateFormat),
      end: this.endDate.clone().add(2, 'w').format(this.__axDateFormat)
    };
  }

  incrementCurrentDateRange(): void {
    this.endDate = this.endDate.add(2, 'w');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/todo_date_range_service.ts